// Bundle entry point. esbuild wraps this as an IIFE -> dist/ahi-banner.js.
import { boot } from "./bootstrap.js";
import { defineBanner } from "./component.js";
import { VERSION } from "./version.js";

export { AhiBanner, defineBanner, renderBannerHTML, parseCopy } from "./component.js";
export {
  BANNER_COLORS,
  BANNER_COPY,
  resolveBannerTreatment,
  type BannerTreatment,
  type BannerDivisionCode,
} from "./divisions.js";
export { LEARN_MORE_HREF, BANNER_ENABLED } from "./config.js";
export { readOverride, type Override } from "./override.js";
export { boot, mount, readAttrs, type BootAttrs } from "./bootstrap.js";
export { VERSION };

declare global {
  interface Window {
    AHIBanner?: {
      version: string;
      boot: typeof boot;
    };
  }
}

if (typeof window !== "undefined") {
  defineBanner();
  // Expose a stable, versioned handle on the host page.
  window.AHIBanner = window.AHIBanner ?? { version: VERSION, boot };
  // Auto-mount from the embedding <script data-division> attribute.
  boot();
}
